import * as Sentry from '@sentry/browser';

const captureError = (error: Error) => {
  Sentry.captureException(error);
};

export default captureError;
